import type { PluginCreator } from 'tailwindcss/types/config'

const shadowColors = {
  'bt-green': '205, 218, 50',
  'bt-grabout-red': '235, 0, 0',
  'bt-blue-ui': '32, 69, 136',
  'bt-grabout-violet': '129, 33, 186'
}

export const btShadowsPlugin: PluginCreator = ({ addUtilities }) => {
  addUtilities(
    Object.fromEntries(
      Object.entries(shadowColors).map(([key, value]) => [
        `.shadow-${key}`,
        { 'box-shadow': `0px 8px 32px 0px rgba(${value}, 0.32)` }
      ])
    )
  )
}
